import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table, Modal, Button } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import TiposDeDocumentoSunatConstant from 'constants/tiposDeDocumentoSunat'

import * as InventarioService from 'services/inventario.service'
import { ZrSwal } from 'utils'

const portletBreadcrumbs = [{ name: 'Ingreso almacen por orden de compra' }]

const tableHeaderRows = [
  { label: 'FECHA', width: 85, align: 'center' },
  { label: 'TIPO', width: 200, align: 'center' },
  {
    label: 'SERIE DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'serieDocumento'
    }
  },
  {
    label: 'NUM DOC',
    width: 105,
    align: 'center',
    filter: {
      type: 'text',
      name: 'numeroDocumento'
    }
  },
  {
    label: 'RUC',
    width: 100,
    align: 'center'
  },
  { label: 'RAZÓN SOCIAL', align: 'center' },
  { label: '', width: 30, align: 'center' }
]

const ListaIngresosAlmacenOrdenCompra = ({ history }) => {
  const __zariContext = React.useContext(ZariContext)

  const tablaRef = React.useRef(null)
  const [detalleVer, setDetalleVer] = React.useState(null)
  const [cargandoDetalle, setCargandoDetalle] = React.useState(false)

  const clickNuevo = React.useCallback(() => {
    history.push(`/${CodigosTransaccionesConstant.INGRESOALMACENPORODENCOMPRA_NUEVA}`)
  }, [history])

  const clickVerDetalle = React.useCallback(
    row => {
      setCargandoDetalle(true)
      setDetalleVer({ cabecera: row, detalles: [] })
      InventarioService.obtenerDetalleIngresoAlmacen(row._id)
        .then(({ data }) => {
          const detalles = (data && data.detalles) || []
          setDetalleVer({ cabecera: row, detalles })
        })
        .catch(err => {
          const msg = err && err.data && err.data.error ? err.data.error : 'Error al cargar detalles'
          __zariContext.snack('error', msg)
        })
        .finally(() => setCargandoDetalle(false))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    id => {
      ZrSwal.showAlert({
        tipo: 'warning',
        mensaje: 'Seguro de eliminar el registro?',
        showCerrar: true,
        onSuccess: () => {
          InventarioService.eliminarxId(id)
            .then(() => {
              __zariContext.snack('success', 'Registro eliminado.')
              tablaRef.current.reload()
            })
            .catch(({ data: { error } }) => __zariContext.snack('error', error))
        }
      })
    },
    [__zariContext]
  )

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Ingreso almacén por orden de compra'
          breadcrumbs={portletBreadcrumbs}
          buttons={[{ name: 'Nuevo', onClick: clickNuevo }]}
        />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            useFilters={true}
            headRows={tableHeaderRows}
            url='/kardex'
            baseParams={{
              tipoConsulta: 'ingreso-almacen-por-ordenes-compra'
            }}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.tipoDocumento ? TiposDeDocumentoSunatConstant.__dictionary[row.tipoDocumento].nombre : '--'}
                </Table.Cell>
                <Table.Cell align='center'>{row.serieDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.numeroDocumento || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.documentoSocio || '--'}</Table.Cell>
                <Table.Cell>{row.nombreSocio || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='ver-detalle'
                        handleClose={handleClose}
                        onClick={e => clickVerDetalle(row)}
                      >
                        Ver Detalle
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => clickEliminar(row._id)}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>

      {detalleVer && (
        <Modal show={true} size='lg' onHide={() => setDetalleVer(null)}>
          <Modal.Header>
            <Modal.Title>
              Detalle del Ingreso · {detalleVer.cabecera.serieDocumento}-{detalleVer.cabecera.numeroDocumento}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className='mb-2' style={{ fontSize: '0.85rem' }}>
              <strong>Fecha:</strong> {detalleVer.cabecera.fechaEmision || '--'} ·{' '}
              <strong>Proveedor:</strong> {detalleVer.cabecera.nombreSocio || '--'}{' '}
              ({detalleVer.cabecera.documentoSocio || '--'})
            </div>
            {cargandoDetalle ? (
              <div className='text-center py-3'>Cargando detalles...</div>
            ) : (
              <div className='table-responsive'>
                <table className='table table-sm table-bordered mb-0' style={{ fontSize: '0.85rem' }}>
                  <thead>
                    <tr>
                      <th>CÓDIGO</th>
                      <th>PRODUCTO</th>
                      <th style={{ width: 80 }}>U. MED</th>
                      <th style={{ width: 80 }}>CANTIDAD</th>
                      <th style={{ width: 100 }}>PRECIO</th>
                      <th style={{ width: 110 }}>SUBTOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(detalleVer.detalles || []).length === 0 && (
                      <tr>
                        <td colSpan={6} className='text-center text-muted'>
                          Sin detalles para mostrar.
                        </td>
                      </tr>
                    )}
                    {(detalleVer.detalles || []).map((d, k) => (
                      <tr key={d._id || k}>
                        <td>{d.codigoProducto || '--'}</td>
                        <td>{d.nombreProducto || '--'}</td>
                        <td className='text-center'>{d.nombreUnidadDeMedida || d.unidadMedida || '--'}</td>
                        <td className='text-right'>{d.cantidad ?? '--'}</td>
                        <td className='text-right'>{d.precio != null ? Number(d.precio).toFixed(2) : '--'}</td>
                        <td className='text-right'>{d.subTotal != null ? Number(d.subTotal).toFixed(2) : '--'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button outline color='secondary' onClick={() => setDetalleVer(null)}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

export default ListaIngresosAlmacenOrdenCompra
